import type { CSSProperties, MouseEvent } from "react";

import { riskPictureCellLabel } from "./cell-label";
import {
  CHANCE_STRIPE_TILE_PX,
  chanceBackground,
  RISK_PICTURE_NEUTRAL_COLOR,
  riskPictureLevelColor,
} from "./risk-picture-colors";
import type { RiskPictureItem } from "./risk-picture-model";
import styles from "./risk-picture.module.css";

interface RiskPictureCellProps {
  item: RiskPictureItem;
  onSelect: () => void;
}

/** Solid code color, or the striped chance wash. Shared with the timeline bars. */
export const riskPictureCellColor = (item: RiskPictureItem): CSSProperties => {
  if (item.kind === "chance" && item.level) {
    const { base, stripes } = chanceBackground(item.level);
    return {
      backgroundColor: base,
      backgroundImage: stripes,
      backgroundSize: `${CHANCE_STRIPE_TILE_PX}px ${CHANCE_STRIPE_TILE_PX}px`,
    };
  }

  const [r, g, b] = item.level
    ? (riskPictureLevelColor(item.level) as [number, number, number])
    : (RISK_PICTURE_NEUTRAL_COLOR as [number, number, number]);
  return { backgroundColor: `rgb(${r} ${g} ${b})` };
};

export const RiskPictureCell = ({ item, onSelect }: RiskPictureCellProps) => {
  const label = riskPictureCellLabel(item);

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    onSelect();
  };

  return (
    <button
      type="button"
      className={styles.cell}
      data-kind={item.kind}
      data-level={item.level}
      style={riskPictureCellColor(item)}
      title={label}
      onClick={handleClick}
    >
      <span className={styles.cellLabel}>{label}</span>
    </button>
  );
};
